
document.addEventListener('DOMContentLoaded', function() {
  const buttons = document.querySelectorAll('.add-to-cart');

  buttons.forEach(button => {
    button.addEventListener('click', function() {
      const variantId = this.getAttribute('data-variant-id');
      const item = {
        id: variantId,
        quantity: 1
      };

      // 予約 / 受注生産の発送時期を明細に引き継ぐ（snippets/preorder-notice.liquid の button_attributes）
      const propertyName = this.getAttribute('data-property-name');
      const propertyValue = this.getAttribute('data-property-value');
      if (propertyName && propertyValue) {
        item.properties = { [propertyName]: propertyValue };
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(item)
      })
      .then(response => response.json())
      .then(data => {
        // カートページにリダイレクト
        window.location.href = '/cart';
      })
      .catch(error => {
        console.error('カートへの追加に失敗しました:', error);
      });
    });
  });
});

